var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full max-w-full md:w-168 lg:w-168 xl:w-192 h-full aspect-video flex justify-center items-center bg-cover",class:{ 'absolute -z-10 top-0 left-0': _vm.absolute },style:(`background-image: url(${_vm.placeholderImage});`)},[_c('div',{staticClass:"border-4 border-blue border-t-transparent rounded-full animate-spin w-20 h-20"})])
}
var staticRenderFns = []

export { render, staticRenderFns }